import { createFileRoute, redirect } from '@tanstack/react-router';
import { ServiceType } from '@mews-commander/data-access';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Services/$serviceId/')({
    loader: async ({ params: { currentEnterpriseId, serviceId }, context: { ensureQueryData } }) => {
        const { services } = await ensureQueryData('services', 'getAll', {
            serviceIds: [serviceId],
            enterpriseIds: [currentEnterpriseId],
        });
        throw redirect({
            to:
                services[0]?.data.discriminator === ServiceType.Bookable
                    ? '/$currentEnterpriseId/Visit/Detail/$serviceId'
                    : '/$currentEnterpriseId/ProductService/Detail/$serviceId',
            params: { currentEnterpriseId, serviceId },
        });
    },
    staticData: {
        owner: MewsTeam.Spacetime,
        type: RouteType.Redirect,
    },
});
